import { motion } from "framer-motion";

export default function Location({ t }) {
  const PLACES = t.location.places;
  return (
    <section data-testid="location-section" className="py-20 md:py-32 bg-pine text-ivory overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="col-span-12 lg:col-span-7"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold mb-4">{t.location.overline}</p>
          <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-6xl leading-[1.1] tracking-tight mb-8">
            {t.location.headingA} <br />
            <span className="italic text-clay">{t.location.headingB}</span>
          </h2>
          <p className="text-ivory/60 text-base md:text-lg leading-relaxed max-w-lg mb-10">
            {t.location.body}
          </p>
          <div className="flex flex-wrap gap-3" data-testid="location-pills">
            {PLACES.map((place) => (
              <div
                key={place.name}
                className="border border-ivory/20 px-5 py-3 hover:border-gold hover:bg-ivory/5 transition-colors duration-300"
              >
                <span className="block font-serif text-lg">{place.name}</span>
                <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-gold mt-1">{place.time}</span>
              </div>
            ))}
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
          className="col-span-12 lg:col-span-5 text-right"
        >
          <p className="font-serif font-light text-[18vw] lg:text-[10vw] leading-none text-outline select-none" aria-hidden="true">
            53.16°N
          </p>
          <p className="font-serif font-light text-[18vw] lg:text-[10vw] leading-none text-outline select-none" aria-hidden="true">
            4.35°W
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ivory/50 mt-6">
            {t.location.coordsLabel}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
